<template>
  <div>
    <div class="empty-state" v-show="dispatches.length === 0">
      <i class="fa fa-address-book fa-4x"></i>
      <span>{{ $t('rsvpDetails.dispatchLogs.emptyState') }}</span>
    </div>

    <!-- list -->
    <div v-for="(log, i) in dispatches" :key="i" class="log">
      <div class="list">
        <div class="date">{{log.created}}</div>
        <div class="message"><span class="status">({{log.status}}) </span>{{log.message}}</div>
        <div class="driver-detail">
          <div class="id">Driver ID: <b><a :href="'/#/provider/' + log.driver.id" target="_blank">{{log.driver.id}}</a></b></div>
          <div class="name">Driver Name: <b>{{log.driver.firstName}} {{log.driver.lastName}}</b></div>
          <div class="email">Driver Email: <b>{{log.driver.email}}</b></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import ApiRsvpDispatch from '@/modules/api/reservation-details/dispatch'

export default {
  name: 'dispatch-logs',
  props: ['rsvpId'],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    dispatches () { return this.$store.state.rsvpDetails.dispatchLogs }
  },
  methods: {
    init () {
      let self = this
      self.loading = true
      self.$store.commit('rsvpDetails/resetDispatchLogs')
      ApiRsvpDispatch.getDispatchLogs(self, self.rsvpId, function (res) {
        self.loading = false
      })
    }
  },
  watch: {
    rsvpId: function (value) {
      this.init()
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.empty-state{
  padding: 30px;
  font-size: 18px;
  color: #999;
  text-align: center;

  .fa{
    display: block;
    margin-bottom: 5px;
    color: #ccc;
    text-shadow:0 0 5px rgba(255,255,255, 1);
  }
}

.log{
  border: 1px solid #ddd;
  width: 100%;
  max-height:auto;
  padding: 10px;
  background: #fafafa;
  overflow: hidden;
  margin-bottom: 10px;

  .list {
    font-size: 11px;
    color: #666;

    .message {
      font-weight: bold;
    }

    .status {
      text-transform: capitalize;
      font-style: italic;
    }

    .driver-detail {
      margin-top: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RsvpDetails/DispatchLogs.vue